module.exports = __webpack_public_path__ + "ProximaNova-SemiboldIt.3584d9676d861761ed50ee8240d39286.woff";